import styled from 'styled-components';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core';

export const HeaderContainer = styled.div`
  padding: 16px;
  padding-bottom: 0px;
`;

export const HeaderTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
`;

export const Title = styled.h2`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 500;
  color: #111b21;
  margin: 0;
  margin-bottom: 4px;

  span {
    color: #00a884;
    font-weight: 600;
  }
`;

export const UnreadBadge = styled.span`
  background-color: #00a884;
  color: white;
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 14px;
`;

export const FilterButton = styled.button`
  background: ${props => props.active ? '#00a884' : 'transparent'};
  border: none;
  padding: 8px;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: ${props => props.active ? '#008f72' : '#f0f2f5'};
  }
`;

export const SearchContainer = styled.div`
  position: relative;
  margin-bottom: 8px;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 8px 12px 8px 40px;
  background-color: #f0f2f5;
  border: none;
  border-radius: 8px;
  color: #111b21;
  font-size: 14px;
  transition: background-color 0.2s ease;

  &:focus {
    outline: none;
    background-color: #e4e6e8;
  }

  &::placeholder {
    color: #667781;
  }
`;

export const FilterModal = styled.div`
  width: 400px;
  height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  position: fixed;
  top: ${props => props.position.top}px;
  left: ${props => props.position.left}px;
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  z-index: 2000;
`;

export const FilterNumberIsActive = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
`;

export const GreenSwitch = withStyles( {
	switchBase: {
		color       : '#00a884',
		'&$checked' : {
			color: '#00a884'
		},
		'&$checked + $track': {
			backgroundColor: '#00a884'
		}
	},
	checked : {},
	track   : {}
} )( Switch );